module.exports = __webpack_public_path__ + "img/line-icon.2cea890c.png";